import React from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';
import Select from './../Select/Select';
import Input from './../Input/Input';
const classNames = require('classnames');

require('./SensorsSettings.scss');

class SensorsSettings extends React.Component {
  render() {
    const { handleSubmit, pristine, reset, submitting, uiInfo, optionList, toggleSettingsDisplay } = this.props;
    const panelClasses = classNames(
      'sensors-settings',
      'alerts-settings',
      { 'show': this.props.showSettings }
    );

    const panelStyle = { height: uiInfo.pageHeight, width: 0.395 * (uiInfo.pageWidth - 10) };

    const statusOptions = [
      { value: 'Not Installed', label: this.context.t('uninstalled') },
      { value: 'Ready', label: this.context.t('ready') },
      { value: 'Active', label: this.context.t('active') },
      { value: 'Non Active', label: this.context.t('inactive') },
    ];

    const withSensorOptions = [
      { value: 'with', label: this.context.t('with') },
      { value: 'without', label: this.context.t('without') },
      { value: 'with_uninstalled', label: this.context.t('with_uninstalled') },
    ]

    return (
      <div className={panelClasses} style={panelStyle}>
        <div className="sensors-header alerts-header">
          <div className="actions">
            <i className="icon-close" onClick={toggleSettingsDisplay} />
          </div>
          <h2>{this.context.t('sensors_options')}</h2>
        </div>
        <form className="form-horizontal" onSubmit={handleSubmit}>
          <fieldset>
            <legend>{this.context.t('sort_by')}</legend>
            <div className="form-group">
              <div className="col-xs-8">
                <Field name="Sensors.sortBy"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    clearable={false}
                    options={[
                      { value: 'id', label: this.context.t('sensor_id_default') },
                      { value: 'SensorStatus', label: this.context.t('status_default') },
                      { value: 'DaysInactive', label: this.context.t('days_inactive') },
                      { value: 'DeviceID', label: this.context.t('device_id') },
                    ]}
                  />)
                  }
                />
              </div>
              <div className="col-xs-4">
                <Field name="Sensors.sortByDir"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    clearable={false}
                    backspaceRemoves={false}
                    options={[
                      { value: 'asc', label: this.context.t('asc') },
                      { value: 'desc', label: this.context.t('desc') },
                    ]}
                  />)
                  }
                />
              </div>
            </div>
            <legend>{this.context.t('sensors_filters')}</legend>
            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('status')}</label>
              <div className="col-xs-8">
                <Field name="Sensors.SensorStatus"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={statusOptions}
                  />)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('sensor_type')}</label>
              <div className="col-xs-8">
                <Field name="Sensors.SensorTypeValue"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={optionList.SensorType}
                  />)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('above_under')}</label>
              <div className="col-xs-8">
                <Field name="Sensors.isUnderground"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={[
                      { value: '0', label: this.context.t('above') },
                      { value: '1', label: this.context.t('under') },
                    ]}
                  />)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('sync_method')}</label>
              <div className="col-xs-8">
                <Field name="Sensors.SyncMethodValue"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={optionList.DeviceTypeSyncMethod}
                  />)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('device_generation')}</label>
              <div className="col-xs-8">
                <Field name="Sensors.Generation"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={[
                      { label: 'G4', value: 'g4' },
                      { label: 'Edge', value: 'edge' },
                      { label: 'Ultra', value: 'ultra' },
                    ]}
                  />)
                  }
                />
              </div>
            </div>
            {this.props.user.advancedMapIndications &&
              <div className="form-group">
                <label className="col-xs-4 control-label">{this.context.t('last_uninstall_reason')}</label>
                <div className="col-xs-8">
                  <Field name="Sensors.LastUninstallReason"
                    component={props =>
                    (<Select {...props}
                      isSearchable={false}
                      placeholderTitle={this.context.t('select')}
                      multi
                      closeMenuOnSelect={false}
                      options={optionList.DeviceMaintenance}
                    />)
                    }
                  />
                </div>
              </div>
            }
            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('hw_type')}</label>
              <div className="col-xs-8">
                <Field name="Sensors.G5DeviceType"
                  component={props =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={[
                      { label: 'BG_INT', value: 1 },
                      { label: 'BG_EXT', value: 2 },
                      { label: 'AG', value: 3 },
                      { label: this.context.t('n_a'), value: 0 },
                    ]}
                  />)
                  }
                />
              </div>
            </div>
            {this.props.user.advancedMapIndications &&
              <div className="form-group">
                <label className="col-xs-4 control-label">{this.context.t('fragmented_file')}</label>
                <div className="col-xs-8">
                  <Field
                    name="Sensors.Fragmented"
                    component={Input}
                    type='checkbox'
                  />
                </div>
              </div>
            }
            {this.props.user.advancedMapIndications &&
              <div className="form-group">
                <label className="col-xs-4 control-label">{this.context.t('resets')}</label>
                <div className="col-xs-8">
                  <Field name="Sensors.Resets"
                    component={Input}
                    type='checkbox'
                  />
                </div>
              </div>
            }

            <legend>{this.context.t('sops_filters')}</legend>
            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('sop_type')}</label>
              <div className="col-xs-8">
                <Field name="SOPs.AvizarCode"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={optionList.AqsCode}
                  />)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('sop_status')}</label>
              <div className="col-xs-8">
                <Field name="SOPs.State"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={optionList.SopStatuses}
                  />)
                  }
                />
              </div>
            </div>
            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('above_under')}</label>
              <div className="col-xs-8">
                <Field name="SOPs.isUnderGround"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={[
                      { value: '0', label: this.context.t('above') },
                      { value: '1', label: this.context.t('under') },
                    ]}
                  />)
                  }
                />
              </div>
            </div>

            <div className="form-group">
              <label className="col-xs-4 control-label">{this.context.t('with_sensor')}</label>
              <div className="col-xs-8">
                <Field name="SOPs.withSensor"
                  component={(props) =>
                  (<Select {...props}
                    isSearchable={false}
                    placeholderTitle={this.context.t('select')}
                    multi
                    closeMenuOnSelect={false}
                    options={withSensorOptions}
                  />)
                  }
                />
              </div>
            </div>

            <div className="text-right">
              <button className="btn btn-success" type="submit" disabled={pristine || submitting} onClick={toggleSettingsDisplay} >{this.context.t('save_and_apply')}</button>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
}

SensorsSettings.contextTypes = {
  t: PropTypes.func.isRequired
};

// Decorate the form component
const sensorsSettings = reduxForm({
  form: 'sensors-settings', // a unique name for this form
  enableReinitialize: true
})(SensorsSettings);

export default sensorsSettings;
